import { render } from "./connect-catalog.vue?vue&type=template&id=58062cb9"
import script from "./connect-catalog.vue?vue&type=script&setup=true&lang=js"
export * from "./connect-catalog.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/connect-catalog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58062cb9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58062cb9', __exports__)) {
    console.log('reload')
    api.reload('58062cb9', __exports__)
  }
  
  module.hot.accept("./connect-catalog.vue?vue&type=template&id=58062cb9", () => {
    console.log('re-render')
    api.rerender('58062cb9', render)
  })

}


export default __exports__